module.exports = __webpack_public_path__ + "img/advantage-1.93ceaf75.png";